/** Roles operativos del ERP (una sola empresa). */
export type UserRole =
  | 'superadmin'
  | 'admin'
  | 'commercial'
  | 'logistics'
  | 'stock'
  | 'billing'
  | 'pending';

/** Proveedor de autenticación usado al crear el perfil. */
export type AuthProvider = 'google' | 'email';

/** Perfil extendido en Firestore (`users/{uid}`). Auth UID es la fuente de identidad. */
export type UserProfile = {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string | null;
  companyId: string;
  role: UserRole;
  /** false = sin acceso al ERP (pendiente de aprobación o deshabilitado). */
  active: boolean;
  provider: AuthProvider;
  createdAt: Date;
  updatedAt: Date;
};

/** Payload para crear o actualizar perfil (superadmin). */
export type UserProfileInput = {
  uid: string;
  email: string;
  displayName: string;
  photoURL?: string | null;
  companyId: string;
  role: UserRole;
  active: boolean;
  provider?: AuthProvider;
};

/** Usuario con acceso completo al ERP (no pendiente ni inactivo). */
export function isUserApproved(profile: UserProfile): boolean {
  return profile.active && profile.role !== 'pending';
}
